<template>
  <div class="detail-page">
    <header class="detail-topbar">
      <div class="topbar-inner">
        <a class="brand" href="/" @click.prevent="goback()">
          <img class="brand-mark" src="/favicon.png" alt="" />
          <span class="brand-copy">
            <span class="brand-text">星空素材网</span>
            <span class="brand-sub">素材资源库</span>
          </span>
        </a>
        <div class="topbar-actions">
          <button type="button" class="mode-chip" @click="toggleTheme">
            {{ themeState.isDark ? "白天" : "夜间" }}
          </button>
          <button type="button" class="back-btn" @click="goback()">
            ← 返回素材库
          </button>
        </div>
      </div>
    </header>

    <main class="detail-main">
      <div class="detail-notice">
        素材资源归漫迷文创工作室所有，需购买后方可使用
      </div>

      <div class="detail-shell">
        <section class="preview-card">
          <div class="detail-head">
            <div class="head-text">
              <h1 :title="detailTitle">{{ detailTitle }}</h1>
              <p>高清预览 · 登录后即可下载素材资源</p>
            </div>
            <span class="vip-tag" v-if="is_model == 2">VIP 专享</span>
            <span class="vip-tag normal" v-else>素材资源</span>
          </div>

          <div class="preview-frame" :class="{ empty: !previewSrc }">
            <img
              v-if="previewSrc"
              :src="previewSrc"
              :alt="detailTitle"
              @error="onPreviewError"
            />
            <div v-else class="preview-empty">
              <strong>暂无预览图</strong>
              <span>仍可尝试下载资源文件</span>
            </div>
          </div>

          <section class="copyright-card" v-if="copyrightSrc">
            <div class="copyright-head">
              <div>
                <h2>版权证书</h2>
                <p>该素材附带作品电子样本 / 版权登记信息</p>
              </div>
              <button
                type="button"
                class="copyright-download"
                @click="downloadCopyright"
              >
                下载证书
              </button>
            </div>
            <a
              class="copyright-frame"
              :href="copyrightSrc"
              target="_blank"
              rel="noreferrer nofollow"
            >
              <img
                :src="copyrightSrc"
                alt="版权证书"
                @error="onCopyrightError"
              />
              <span class="copyright-tip">点击查看大图</span>
            </a>
          </section>
        </section>

        <aside class="side-panel">
          <section class="download-card">
            <h2>资源下载</h2>
            <p class="download-desc">
              {{
                is_model == 2
                  ? "此资源为 VIP 专享资源，登录后可下载"
                  : "此资源为会员下载资源，登录后可下载"
              }}
            </p>
            <ul class="meta-list">
              <li><span>资源名称</span><strong>{{ detailTitle || "—" }}</strong></li>
              <li>
                <span>资源类型</span>
                <strong>{{ is_model == 2 ? "VIP 模型素材" : "普通素材" }}</strong>
              </li>
            </ul>
            <div class="download-actions">
              <button type="button" class="btn-download" @click="download()">
                立即下载
              </button>
              <button
                type="button"
                class="btn-download ghost"
                @click="downmodel()"
                v-if="is_model == 2"
              >
                立即下载模型
              </button>
            </div>
          </section>

          <section class="rules-card">
            <h2>使用说明</h2>
            <ol>
              <li>本站所有资源来源于本司画师手动所画。</li>
              <li>本站提供的素材、模板等资源，均需购买后方可使用。</li>
              <li>如有链接无法下载、失效或广告，请联系右下角客服处理。</li>
            </ol>
          </section>

          <section class="tips-card">
            <h2>温馨提示</h2>
            <p>
              下载前请确认已登录账号。若提示登录过期，重新登录后再试即可。
            </p>
          </section>
        </aside>
      </div>
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-main">
          <strong class="footer-name">星空素材网</strong>
          <p>高质量简笔画多人物素材，推荐有价值的好东西资源分享</p>
        </div>
        <div class="footer-legal">
          <span>山西壹拾贰网络科技有限公司 版权所有</span>
          <span class="dot" aria-hidden="true">·</span>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer nofollow"
            >晋ICP备2024033569号-2</a
          >
        </div>
      </div>
    </footer>

    <div class="mengban" v-if="loginShow">
      <div class="loginbox" v-if="isLogin">
        <div class="loginbox_left">
          <div class="login_title">
            <h3>登录</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input
            v-model="username"
            class="input_box"
            placeholder="请输入用户名/邮箱"
            @keyup.enter="login_btn"
          >
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="password"
            class="input_box"
            placeholder="请输入密码"
            type="password"
            @keyup.enter="login_btn"
          >
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>

          <div class="login_btn bgcolor" @click="login_btn()">立即登录</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>
          <div class="bottom_box">
            <div class="box_left" @click="isLogin = false">
              没有账号？立即注册
            </div>
            <div class="box_right"></div>
          </div>
        </div>
        <div class="loginbox_right">
          <div class="login-notice">
            <span class="notice-badge">重要的事情说三遍</span>
            <div class="notice-block">
              <h4>素材版权问题</h4>
              <p>
                本素材最终解释权归漫迷文创所有，所有素材均享有国家著作权，付费购买后不意味着拥有此版权，仅拥有个人使用权。
              </p>
            </div>
            <div class="notice-block">
              <h4 class="accent">授权问题</h4>
              <p>
                每个用户可授权 3 个账号使用。如未授权一经发现，将进行法律责任追寻。
              </p>
            </div>
            <div class="notice-tips">
              <p>· 请妥善保管账号，勿分享给未授权人员</p>
              <p>· 抖音昵称及账号在抖音平台不允许修改</p>
              <p>· 付费后仅获得个人使用权，不代表拥有版权</p>
            </div>
          </div>
        </div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
      <div class="loginbox registerbox" v-else>
        <div class="loginbox_left">
          <div class="login_title">
            <h3>注册账号</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎加入星空素材网</span>
              <em></em>
            </p>
          </div>

          <div class="register-fields">
            <el-input v-model="email" class="input_box" placeholder="请输入邮箱">
              <template #prefix>
                <img src="../../src/assets/login/email.png" alt="" />
              </template>
            </el-input>
            <el-input
              v-model="username"
              class="input_box"
              placeholder="请输入用户名"
            >
              <template #prefix>
                <img src="../../src/assets/login/user.png" alt="" />
              </template>
            </el-input>
            <div class="pwd-row">
              <el-input
                v-model="password"
                class="input_box"
                placeholder="请输入密码"
                type="password"
              >
                <template #prefix>
                  <img src="../../src/assets/login/password.png" alt="" />
                </template>
              </el-input>
              <el-input
                v-model="confirm_password"
                class="input_box"
                placeholder="再次输入密码"
                type="password"
              >
                <template #prefix>
                  <img src="../../src/assets/login/password.png" alt="" />
                </template>
              </el-input>
            </div>
          </div>

          <div class="xieyi">
            <input
              v-model="isAgree"
              id="agreement"
              name="agreen"
              type="checkbox"
              class="agreen_btn"
              required=""
            />
            我已阅读并同意
            <a href="#" @click.prevent="agreementShow = true">《注册协议》</a>
          </div>
          <div class="login_btn bgcolor" @click="register_btn()">立即注册</div>

          <div class="bottom_box">
            <div class="box_left" @click="isLogin = true">
              已有账号？立即登录
            </div>
          </div>
        </div>
        <div class="loginbox_right">
          <div class="login-notice">
            <span class="notice-badge">注册前请阅读</span>
            <div class="notice-block">
              <h4>账号说明</h4>
              <p>
                请使用常用邮箱注册，便于找回密码。抖音昵称及账号在抖音平台不允许修改，请按要求完善授权信息。
              </p>
            </div>
            <div class="notice-block">
              <h4>素材版权问题</h4>
              <p>
                本素材最终解释权归漫迷文创所有，所有素材均享有国家著作权，付费购买后仅拥有个人使用权，不代表拥有版权。
              </p>
            </div>
            <div class="notice-block">
              <h4 class="accent">授权问题</h4>
              <p>
                每个用户可授权 3 个账号使用。如未授权一经发现，将进行法律责任追寻。
              </p>
            </div>
          </div>
        </div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
    </div>

    <RegisterAgreement
      v-model="agreementShow"
      @accept="isAgree = true"
    />
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import {
  register,
  login,
  downData,
  downModel,
} from "@/api/api.js";
import { ref, computed, onMounted, onActivated, onBeforeUnmount } from "vue";
import { ElMessage } from "element-plus";
import { useTheme } from "@/theme";
import RegisterAgreement from "@/components/RegisterAgreement.vue";

const router = useRouter();
const route = useRoute();
const { themeState, toggleTheme } = useTheme();

const detailId = computed(() => route.query.id);
const detailTitle = computed(() => route.query.post_title || "");
const image_cover = ref(route.query.image_cover || "");
const copyright_image = ref(route.query.post_content || "");
const is_model = computed(() => route.query.is_model);
const previewBroken = ref(false);
const copyrightBroken = ref(false);

const isImageUrl = (src) => {
  if (!src || typeof src !== "string") return "";
  const value = src.trim();
  if (!value) return "";
  // 排除明显是 HTML 内容的字段，避免当成图片地址
  if (value.includes("<") || value.includes(">")) return "";
  return value;
};

const previewSrc = computed(() => {
  if (previewBroken.value) return "";
  return isImageUrl(image_cover.value);
});

const copyrightSrc = computed(() => {
  if (copyrightBroken.value) return "";
  return isImageUrl(copyright_image.value);
});

const onPreviewError = () => {
  previewBroken.value = true;
};

const onCopyrightError = () => {
  copyrightBroken.value = true;
};

const downloadCopyright = async () => {
  const src = copyrightSrc.value;
  if (!src) return;
  const filename = `${detailTitle.value || "版权证书"}-版权证书.jpg`;
  try {
    const response = await fetch(src);
    if (!response.ok) throw new Error("download failed");
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch (error) {
    // 跨域受限时退回新窗口打开，便于用户自行保存
    window.open(src, "_blank", "noopener,noreferrer");
  }
};

const syncDetailFromRoute = () => {
  image_cover.value = route.query.image_cover || "";
  copyright_image.value = route.query.post_content || "";
  previewBroken.value = false;
  copyrightBroken.value = false;
};
const loginShow = ref(false);
const isLogin = ref(true);
const username = ref("");
const password = ref("");
const confirm_password = ref("");
const email = ref("");
const isAgree = ref(false);
const agreementShow = ref(false);
const isUserLogin = ref(localStorage.getItem("token"));

const resetPageScroll = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const login_btn = () => {
  if (username.value && password.value) {
    const formData = new FormData();
    formData.append("username", username.value);
    formData.append("password", password.value);

    login(formData).then((res) => {
      if (res.code === 100) {
        localStorage.setItem("token", res.data.token);
        ElMessage.success("登录成功");
        isUserLogin.value = res.data.token;
        loginShow.value = false;
      }
    });
  } else {
    ElMessage.error("用户名或密码不能为空");
  }
};

const register_btn = () => {
  if (!isAgree.value) {
    ElMessage.error("请先同意协议");
    return;
  }
  if (
    email.value &&
    username.value &&
    password.value &&
    confirm_password.value
  ) {
    if (password.value === confirm_password.value) {
      const formData = new FormData();
      formData.append("username", username.value);
      formData.append("password", password.value);
      formData.append("email", email.value);
      formData.append("confirm_password", confirm_password.value);
      register(formData).then((res) => {
        if (res.code === 100) {
          ElMessage.success("注册成功");
        }
      });
    } else {
      ElMessage.error("两次密码输入不一致");
    }
  } else {
    ElMessage.error("邮箱、用户名、密码不能为空");
  }
};

onMounted(() => {
  setRemUnit();
  window.addEventListener("resize", setRemUnit);
  syncDetailFromRoute();
  resetPageScroll();
});

onActivated(() => {
  syncDetailFromRoute();
  resetPageScroll();
});

const download = () => {
  downData({
    id: detailId.value,
    token: localStorage.getItem("token"),
  }).then((res) => {
    if (res.code === 100) {
      let url = res.data;
      if (url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }
      window.location.href = url;
    } else if (
      res.msg == "token值不能为空" ||
      res.msg == "登陆已过期请重新登陆"
    ) {
      loginShow.value = true;
    }
  });
};

const downmodel = () => {
  downModel({
    id: detailId.value,
    token: localStorage.getItem("token"),
  }).then((res) => {
    if (res.code === 100) {
      let url = res.data;
      if (url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }
      window.location.href = url;
    } else if (
      res.msg == "token值不能为空" ||
      res.msg == "登陆已过期请重新登陆"
    ) {
      loginShow.value = true;
    }
  });
};

const setRemUnit = () => {
  const baseSize = 16;
  const scale = document.documentElement.clientWidth / 1920;
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};

const goback = () => {
  router.push({ path: "/" });
};

onBeforeUnmount(() => {
  window.removeEventListener("resize", setRemUnit);
});
</script>

<style lang="scss" scoped>
.detail-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--xk-ink);
  background: var(--xk-page-bg);
  transition: color 0.25s ease, background 0.25s ease;
}

.detail-topbar {
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(14px);
  background: var(--xk-topbar-bg);
  border-bottom: 1px solid var(--xk-line);
}

.topbar-inner {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0.85rem clamp(1rem, 2.2vw, 2rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: var(--xk-ink);
  min-width: 0;
}

.brand-mark {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  object-fit: cover;
  display: block;
  box-shadow: 0 4px 12px rgba(11, 120, 196, 0.18);
  background: #0b1220;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  line-height: 1.1;
}

.brand-text {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.28rem;
  letter-spacing: 0.04em;
}

.brand-sub {
  font-size: 0.68rem;
  color: var(--xk-muted);
  letter-spacing: 0.12em;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.mode-chip {
  border: 1px solid var(--xk-line);
  background: var(--xk-soft);
  color: var(--xk-sky-deep);
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.45rem 0.75rem;
  border-radius: 0.6rem;
  cursor: pointer;
}

.back-btn {
  border: 1px solid var(--xk-line);
  background: var(--xk-paper);
  color: var(--xk-sky-deep);
  font: inherit;
  font-size: 0.92rem;
  font-weight: 600;
  padding: 0.5rem 0.9rem;
  border-radius: 0.65rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: var(--xk-soft);
    transform: translateX(-2px);
  }
}

.detail-main {
  flex: 1;
  width: min(1760px, 98vw);
  margin: 0 auto;
  padding: 1.35rem 1rem 2.75rem;
}

.detail-notice {
  margin-bottom: 1.15rem;
  padding: 0.9rem 1.15rem;
  border-radius: 0.9rem;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(120deg, #5b4cdb 0%, #7a6cf0 55%, #8f7dff 100%);
  box-shadow: 0 10px 24px rgba(91, 76, 219, 0.18);
}

.detail-shell {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(300px, 0.75fr);
  gap: 1.15rem;
  align-items: start;
}

.preview-card,
.download-card,
.rules-card,
.tips-card {
  background: var(--xk-card-bg);
  border: 1px solid var(--xk-line);
  border-radius: 1.15rem;
  box-shadow: 0 12px 28px rgba(11, 120, 196, 0.06);
}

.preview-card {
  padding: 1.15rem 1.2rem 1.25rem;
  min-height: 640px;
  display: flex;
  flex-direction: column;
}

.detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.head-text {
  min-width: 0;
  flex: 1;

  h1 {
    margin: 0 0 0.35rem;
    font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
    font-size: clamp(1.55rem, 2.6vw, 2.1rem);
    font-weight: 400;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: var(--xk-muted);
    font-size: 0.9rem;
  }
}

.vip-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.75rem;
  border-radius: 0.5rem;
  background: linear-gradient(90deg, #ff5f7a, #ff8a65);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  flex-shrink: 0;

  &.normal {
    background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  }
}

.preview-frame {
  flex: 1;
  border-radius: 1rem;
  overflow: hidden;
  background:
    linear-gradient(160deg, #e8f5fc 0%, #f4f8fb 55%, #eef2f7 100%);
  min-height: 480px;
  display: grid;
  place-items: center;

  &.empty {
    min-height: 420px;
  }

  img {
    width: 100%;
    max-height: min(72vh, 820px);
    height: auto;
    object-fit: contain;
    display: block;
    background: var(--xk-paper);
  }
}

.preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: var(--xk-muted);
  padding: 3rem 1rem;

  strong {
    font-size: 1.05rem;
    color: var(--xk-ink);
  }

  span {
    font-size: 0.88rem;
  }
}

.copyright-card {
  margin-top: 1rem;
  padding: 1rem 1.05rem 1.1rem;
  border-radius: 1rem;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
}

.copyright-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  margin-bottom: 0.75rem;

  h2 {
    margin: 0 0 0.25rem;
    font-size: 1rem;
    color: var(--xk-ink);
  }

  p {
    margin: 0;
    font-size: 0.82rem;
    color: var(--xk-muted);
  }
}

.copyright-download {
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.84rem;
  font-weight: 600;
  padding: 0.48rem 0.9rem;
  border-radius: 0.65rem;
  color: #fff;
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(11, 120, 196, 0.28);
  }
}

.copyright-frame {
  position: relative;
  display: block;
  border-radius: 0.75rem;
  overflow: hidden;
  background: var(--xk-soft);
  border: 1px solid var(--xk-line);
  text-decoration: none;

  img {
    width: 100%;
    height: auto;
    display: block;
    max-height: 420px;
    object-fit: contain;
    background: #f7f3ea;
  }

  &:hover .copyright-tip {
    opacity: 1;
  }
}

.copyright-tip {
  position: absolute;
  left: 0.75rem;
  bottom: 0.75rem;
  padding: 0.28rem 0.6rem;
  border-radius: 999px;
  background: rgba(15, 40, 70, 0.72);
  color: #fff;
  font-size: 0.75rem;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}

.side-panel {
  position: sticky;
  top: 5.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.download-card,
.rules-card,
.tips-card {
  padding: 1.15rem 1.2rem 1.25rem;
}

.download-card h2,
.rules-card h2,
.tips-card h2 {
  margin: 0 0 0.7rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--xk-sky);
}

.download-desc {
  margin: 0 0 0.9rem;
  color: var(--xk-muted);
  font-size: 0.9rem;
  line-height: 1.55;
}

.meta-list {
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  display: grid;
  gap: 0.55rem;

  li {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.65rem 0.75rem;
    border-radius: 0.7rem;
    background: var(--xk-soft);
    border: 1px solid var(--xk-line);
    font-size: 0.86rem;
  }

  span {
    color: var(--xk-muted);
    flex-shrink: 0;
  }

  strong {
    color: var(--xk-ink);
    font-weight: 600;
    text-align: right;
    word-break: break-all;
  }
}

.download-actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.btn-download {
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.98rem;
  font-weight: 600;
  padding: 0.85rem 1.2rem;
  border-radius: 0.8rem;
  color: #fff;
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  box-shadow: 0 8px 18px rgba(11, 120, 196, 0.25);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &.ghost {
    background: var(--xk-paper);
    color: var(--xk-sky);
    border: 1px solid var(--xk-line);
    box-shadow: none;
  }
}

.rules-card ol {
  margin: 0;
  padding-left: 1.15rem;
  color: var(--xk-muted);
  font-size: 0.88rem;
  line-height: 1.75;
}

.rules-card li + li {
  margin-top: 0.35rem;
}

.tips-card {
  background: var(--xk-soft);
  border-color: var(--xk-line);

  p {
    margin: 0;
    color: var(--xk-muted);
    font-size: 0.88rem;
    line-height: 1.65;
  }
}

.site-footer {
  margin-top: auto;
  background: var(--xk-footer-bg);
  color: var(--xk-footer-text);
  border-top: 1px solid var(--xk-footer-line);
}

.footer-inner {
  max-width: min(980px, 94vw);
  margin: 0 auto;
  padding: 1.6rem 1rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  text-align: center;
}

.footer-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.footer-name {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.15rem;
  font-weight: 400;
  letter-spacing: 0.04em;
  color: var(--xk-footer-title);
}

.footer-main p {
  margin: 0;
  max-width: 28rem;
  line-height: 1.6;
  font-size: 0.88rem;
  color: var(--xk-footer-text);
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.35rem 0.55rem;
  font-size: 0.8rem;
  color: var(--xk-footer-muted);
  padding-top: 0.75rem;
  border-top: 1px solid var(--xk-footer-line);
  width: min(100%, 36rem);

  a {
    color: var(--xk-footer-link);
    text-decoration: none;

    &:hover {
      color: var(--xk-sky);
    }
  }

  .dot {
    opacity: 0.55;
  }
}

@media (max-width: 1100px) {
  .detail-shell {
    grid-template-columns: 1fr;
  }

  .side-panel {
    position: static;
    order: -1;
  }

  .preview-card {
    min-height: auto;
  }

  .download-actions {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .btn-download {
    flex: 1;
    min-width: 140px;
  }
}

@media (max-width: 640px) {
  .detail-notice {
    font-size: 0.86rem;
    text-align: left;
  }

  .preview-frame {
    min-height: 280px;
  }

  .footer-legal {
    flex-direction: column;
    gap: 0.35rem;

    .dot {
      display: none;
    }
  }
}
</style>
